<template>
  <div>
    <button
      @click="onResetClick"
      :class="buttonClass"
      :aria-label="ariaLabel"
    ></button>
    <modal ref="resetModal" white-blur no-close-on-backdrop>
      <template v-slot:content>
        <div class="reset-modal">
          <h2 class="reset-modal__title" tabindex="0">
            {{ title }}
          </h2>
          <p class="reset-modal__description" tabindex="0">
            {{ description }}
          </p>
          <div class="reset-modal-buttons">
            <button class="button button--cancel" @click="hideModal">
              {{ textCancelBtn }}
            </button>
            <button class="button button--restart" @click="onResetGame">
              {{ textRestartBtn }}
            </button>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from '../../Modal';

export default {
  name: 'ResetButton',
  components: {
    Modal,
  },
  props: {
    ariaLabel: {
      type: String,
      default: 'Reset',
    },
    title: {
      type: String,
      default: 'Restart',
    },
    description: {
      type: String,
      default: 'Are you sure you want to restart?',
    },
    textCancelBtn: {
      type: String,
      default: 'Cancel',
    },
    textRestartBtn: {
      type: String,
      default: 'Yes, Restart',
    },
    iconColor: {
      type: String,
      default: 'white',
    },
    iconHover: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    buttonClass() {
      const classes = {
        'reset-button': true,
        'font-icon-reset-app-icon': true,
      };

      classes[`icon-font-color-${this.iconColor}`] = !!this.iconColor;
      classes[`icon-font-color-${this.iconHover}-hover-state`] =
        !!this.iconHover;

      return classes;
    },
    restartText() {
      return this.title
        ? `${this.title}. ${this.description}`
        : this.description;
    },
  },
  methods: {
    onResetClick() {
      this.$refs.resetModal.show();
    },
    hideModal() {
      this.$refs.resetModal.hide();
      this.$emit('on-cancel-reset');
    },
    onResetGame() {
      this.$refs.resetModal.hide();
      this.$emit('on-reset');
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/reset_button.styl';
</style>
